import { render } from "./UpdateAccessActivity.vue?vue&type=template&id=4a5b09ab&scoped=true"
import script from "./UpdateAccessActivity.vue?vue&type=script&lang=js"
export * from "./UpdateAccessActivity.vue?vue&type=script&lang=js"

import "./UpdateAccessActivity.vue?vue&type=style&index=0&id=4a5b09ab&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5b09ab"]])

export default __exports__